var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertUrgent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 16.5C27 17.505 27 18.495 27 19.5C28.8 19.5 31.14 19.5 33 19.5C33 18.495 33 17.505 33 16.5C31.14 16.5 28.8 16.5 27 16.5Z",
    fill: "#C61616"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 26.415C25.44 27.48 27.315 28.89 28.8 30C29.4 29.205 30 28.395 30.6 27.6C29.115 26.49 27.24 25.08 25.8 24C25.2 24.81 24.6 25.62 24 26.415Z",
    fill: "#C61616"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6 8.4C30 7.605 29.4 6.795 28.8 6C27.315 7.11 25.44 8.52 24 9.6C24.6 10.395 25.2 11.205 25.8 12C27.24 10.92 29.115 9.525 30.6 8.4Z",
    fill: "#C61616"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 13.5C4.35 13.5 3 14.85 3 16.5V19.5C3 21.15 4.35 22.5 6 22.5H7.5V28.5H10.5V22.5H12L19.5 27V9L12 13.5H6ZM13.545 16.065L16.5 14.295V21.705L13.545 19.935L12.825 19.5H12H6V16.5H12H12.825L13.545 16.065Z",
    fill: "#C61616"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.25 18C23.25 16.005 22.38 14.205 21 12.975V23.01C22.38 21.795 23.25 19.995 23.25 18Z",
    fill: "#C61616"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertUrgent);
export default __webpack_public_path__ + "static/media/AlertUrgent.b2b48e06ecf6a4fbd7eb9c972f93a64c.svg";
export { ForwardRef as ReactComponent };